// extracted by mini-css-extract-plugin
module.exports = {"ReplyButton":"pt_a bhu_vr bhu_iv bhu_wf bhu_i bhu_j bhu_q bhu_un bhu_en bhu_ri bhu_rj bhu_cx","ReplyButton__icon":"pt_b bhu_re"};